var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 228,
    viewBox: "0 0 240 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 115.186C240 190.027 176.351 228 97.8351 228C19.3196 228 27.5 184.342 27.5 109.5C27.5 34.6584 19.3196 0 97.8351 0C176.351 0 240 40.3442 240 115.186Z",
    fill: "#262E31"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 130,
    height: 64,
    rx: 32,
    fill: "#14DCA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 184.5C94.5 191.956 84.4264 198 72 198C59.5736 198 53 191.956 53 184.5C53 177.044 59.5736 171 72 171C84.4264 171 94.5 177.044 94.5 184.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.be91ad11c4f939fb62a4e3f3025a1ae9.svg";
export { ForwardRef as ReactComponent };